import axios from 'axios'

export const fetchVisitorGeography = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
    
    axios.post('/website/fetchVisitorLocation.php', payload)
    .then(res => {
        console.log(JSON.stringify(res.data))
        commit('setVisitorGeographyDetail', res.data)
        dispatch('loadCountryList')        
    })
    .catch(error => {
        console.log(error)
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

export const submitLead = ({commit}, payload) => {

    commit('toggleLoadingState', true)
    axios.post('/website/submitLead.php', payload)
    .then(res => {
        console.log(res.data)
        if(res.data.status) {
            commit('setFormSubmittedStatus', res.data.message)
        } else {
            commit('setSignupFormWarning', res.data.message)    
        }
        
    })
    .catch(error => {
        console.log(error)
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}


/*** MASTER DATA ***/

export const loadCountryList = ({commit}, payload) => {

    commit('toggleLoadingState', true)
    axios.post('/website/loadCountryList.php', payload)
    .then(res => {
        
        commit('setCountryList', res.data.country_list)              

    })
    .catch(error => {
        console.log(error)
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}


// WEBPACK FOOTER //
// ./src/store/modules/master/actions.js